module.exports = __webpack_public_path__ + "static/img/avatar-s-7.cb1b1e65.jpg";